import React from 'react'
import { useTranslation } from 'react-i18next'
import { BuildingCharacteristics } from '../../../../BuildingCharacteristics'
import { useAnalysisMode } from '../../../contexts/AnalysisModeContext'

/**
 * Shared BuildingCharacteristicsTab wrapper for analysis views.
 * Reads entity data from AnalysisModeContext and delegates
 * to the existing BuildingCharacteristics component.
 */
export const BuildingCharacteristicsTab: React.FC = () => {
  const { t } = useTranslation('characteristics')
  const { entity } = useAnalysisMode()

  if (!entity?.building && !entity?.buildingCharacteristics) {
    return null
  }

  return (
    <BuildingCharacteristics
      building={entity?.buildingCharacteristics || entity}
      t={t}
    />
  )
}
